import { SxProps, Theme } from '@mui/material';

/** Hero two-column wrapper (only rendered when `heading` prop is provided) */
export const heroWrapperStyles: SxProps<Theme> = {
	display: 'flex',
	flexDirection: { xs: 'column', md: 'row' },
	alignItems: { xs: 'stretch', md: 'center' },
	justifyContent: 'space-between',
	gap: { xs: 4, md: 8 },
	px: { xs: 3, md: 10 },
	py: { xs: 6, md: 10 },
	width: '100%',
};

export const heroContentStyles: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	gap: 3,
	flex: 1,
	color: 'common.white',
};

export const heroEyebrowStyles: SxProps<Theme> = {
	typography: 'bodyMediumBook',
	color: 'common.white',
};

export const heroHeadingStyles: SxProps<Theme> = {
	typography: { xs: 'header3', md: 'display2' },
	color: 'common.white',
};

export const heroDescriptionStyles: SxProps<Theme> = {
	typography: 'bodyLargeBook',
	color: 'common.white',
};

export const heroPhoneStyles: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	gap: 1,
	typography: 'bodyLargeBook',
	color: 'common.white',
};

export const formCardStyles: SxProps<Theme> = {
	backgroundColor: 'white',
	borderRadius: '1rem',
	padding: { xs: '2rem 1.5rem', md: '3rem 2.5rem' },
	display: 'flex',
	flexDirection: 'column',
	gap: 2,
	width: { xs: '100%', md: '480px' },
	flexShrink: 0,
	boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.12)',
};

export const formTitleStyles: SxProps<Theme> = {
	fontFamily: 'Beausite Classic',
	fontSize: { xs: '1.75rem', md: '2rem' },
	fontWeight: 500,
	color: '#0A2F54',
	lineHeight: 1.3,
	mb: 1,
};

export const fieldStyles: SxProps<Theme> = {
	width: '100%',
};

/**
 * Schedule button color styles. ClearChoice sources its blue CTA treatment
 * from the theme's `accent01` palette (the same tokens the `primaryAccent1`
 * MUI Button variant uses), so palette changes at the theme level are
 * reflected here automatically. All other brands keep the original amber
 * treatment.
 */
export const scheduleButtonStyles = (isClearChoice: boolean, theme: Theme): SxProps<Theme> => ({
	alignSelf: 'flex-end',
	mt: 1,
	padding: '0.875rem 2rem',
	fontWeight: 400,
	textTransform: 'none',
	fontSize: '1rem',
	borderRadius: '2rem',
	fontFamily: 'Beausite Classic',
	boxShadow: 'none',
	...(isClearChoice
		? {
				backgroundColor: theme.palette.accent01.main,
				color: theme.palette.text.light,
				'&:hover': {
					backgroundColor: theme.palette.accent01.main,
					boxShadow: 'none',
				},
				'&:active': {
					backgroundColor: theme.palette.accent01.dark,
					boxShadow: 'none',
				},
				'&.Mui-disabled': {
					backgroundColor: '#F0F4F7',
					color: '#A8B1BA',
				},
		  }
		: {
				backgroundColor: '#E89B4C',
				color: '#0A2F54',
				'&:hover': {
					backgroundColor: '#D88A3B',
					boxShadow: 'none',
				},
				'&:active': {
					boxShadow: 'none',
				},
				'&.Mui-disabled': {
					backgroundColor: '#D1D9E2',
					color: '#8A9BAD',
					boxShadow: 'none',
				},
		  }),
});
